import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../assets/images/logo.svg";
import logo_dark from "../assets/images/logo_dark.svg";
import $ from "jquery";
import ThemeToggle from "./ThemeToggle";
import { useTheme } from "./ThemeContext";
import { useTranslation } from "react-i18next";
import { Dropdown, Image } from "react-bootstrap";
import { getLang, setLang } from "../lib/localStorage";
import isEmpty from "../lib/isEmpty";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function NavbarNew(props) {
  // dispatch
  const { isAuth } = useSelector((state) => state.auth);
  const { theme } = useTheme();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  function loadScript() {
    // Navbar Sticky
    var t = $(".navbar-sticky");
    $(window).on("scroll load", function (e) {
      var e = $(window).scrollTop();
      120 <= e
        ? t.addClass("navbar-sticky--moved-up")
        : t.removeClass("navbar-sticky--moved-up");
      250 <= e
        ? t.addClass("navbar-sticky--transitioned")
        : t.removeClass("navbar-sticky--transitioned");
      500 <= e
        ? t.addClass("navbar-sticky--on")
        : t.removeClass("navbar-sticky--on");
    });

    $(document).ready(function () {
      $(".auth_btn_grp .primary_btn").click(function () {
        $("body").css({ overflow: "unset" });
      });
    });
  }

  const langList = [
    {
      value: "en",
      image: require("../assets/images/EN.png"),
      label: "English",
    },
    { value: "ar", image: require("../assets/images/AR.png"), label: "Arabic" },
    { value: "fr", image: require("../assets/images/FR.png"), label: "French" },
    {
      value: "sp",
      image: require("../assets/images/SP.png"),
      label: "Spanish",
    },
    {
      value: "de",
      image: require("../assets/images/DE.png"),
      label: "Deutsch",
    },
  ];

  const [defaultLang, setDefaultLang] = useState({
    value: "en",
    image: require("../assets/images/EN.png"),
    label: "English",
  });

  const [language, setLanguage] = useState("en");

  const [menuOpen, setMenuOpen] = useState(false);

  const [hoveredMenuItem, setHoveredMenuItem] = useState(null);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "#about" },
    { name: "Services", path: "#services" },
    { name: "Our Approach", path: "#approach" },
    { name: "Clients", path: "#clients" },
    { name: "Insights", path: "#insights" },
    { name: "Contact", path: "#contact" },
  ];

  const handleLanguage = (lang, option) => {
    setLang(lang);
    setLanguage(lang);
    setDefaultLang(option);
    i18n.changeLanguage(lang);
    window.location.reload();
  };

  useEffect(() => {
    let langCode = getLang();

    if (isEmpty(langCode)) {
      setLang(language);
      i18n.changeLanguage(language);
    } else {
      setLang(langCode);
      i18n.changeLanguage(langCode);
      const selectedLang = langList.find((item) => item.value === langCode);
      if (selectedLang) setDefaultLang(selectedLang);
      setLanguage(langCode);
    }
  }, [language]);

  useEffect(() => {
    loadScript();
  }, []);

  // Prevent scrolling when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  const drawerVariants = {
    hidden: { y: "-100%" },
    visible: {
      y: 0,
      transition: {
        duration: 1.2,
        ease: [0.76, 0, 0.24, 1], // cinematic smooth easeInOut
      },
    },
    exit: {
      y: "-100%",
      transition: {
        duration: 1.2,
        ease: [0.76, 0, 0.24, 1],
        delay: 0.4, // Wait for links to stagger out before sliding up
      },
    },
  };

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
    exit: {
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1, // Stagger in reverse on close
      },
    },
  };

  const itemVariants = {
    hidden: {
      y: 80,
      opacity: 0,
      clipPath: "inset(0 0 100% 0)",
    },
    visible: {
      y: 0,
      opacity: 1,
      clipPath: "inset(0 0 0% 0)",
      transition: {
        duration: 2.2,
        ease: [0.22, 1, 0.36, 1], // easeOutQuint
      },
    },
    exit: {
      y: 40,
      opacity: 0,
      clipPath: "inset(0 0 100% 0)",
      transition: {
        duration: 0.6,
        ease: [0.76, 0, 0.24, 1],
      },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 1.1, filter: "blur(10px)" },
    visible: {
      opacity: 1,
      scale: 1,
      filter: "blur(0px)",
      transition: {
        delay: 0.6,
        duration: 1.5,
        ease: [0.22, 1, 0.36, 1],
      },
    },
    exit: {
      opacity: 0,
      scale: 1.05,
      filter: "blur(10px)",
      transition: {
        duration: 0.6,
        ease: [0.76, 0, 0.24, 1],
      },
    },
  };

  return (
    <>
      {/* NAVBAR */}
      <motion.div
        className="w-full px-2 md:px-6 py-3 md:py-6 flex justify-between items-center navbar-sticky z-1"
        animate={{
          opacity: menuOpen ? 0.3 : 1,
          backgroundColor: menuOpen
            ? "rgba(57, 86, 69, 0.1)"
            : "rgba(255 255 255, 0.7)",
        }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      >
        <motion.div
          animate={{
            scale: menuOpen ? 0.95 : 1,
          }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <Link className="" to="/">
            <img src={logo} className="img-fluid brand_logo" alt="Light logo" />
          </Link>
        </motion.div>

        {/* center */}
        <motion.button
          onClick={() => setMenuOpen(true)}
          animate={{
            rotate: menuOpen ? 90 : 0,
          }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2 11H30M2 22H30" stroke="#395645" strokeWidth="1.5" />
          </svg>
        </motion.button>

        {/* menu close */}
        <motion.div
          className="flex gap-2"
          animate={{
            opacity: menuOpen ? 0.3 : 1,
            scale: menuOpen ? 0.95 : 1,
          }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <Link to="/contact" className="primary_btn_outline hidden md:block">
            Request a Consultation
          </Link>
          {!isAuth && (
            <Link to="/login" className="primary_btn">
              {t("LOGIN")}
            </Link>
          )}
        </motion.div>
        {/* menu open */}
      </motion.div>

      {/* MENU DRAWER */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            variants={drawerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-0 z-50 bg-[#395645] text-white overflow-hidden h-full lg:h-2/4"
          >
            {/* TOP BAR */}
            <div className="w-full px-6 pt-6 pb-6 flex justify-between items-center">
              <Link className="" to="/">
                <img
                  src={logo_dark}
                  className="img-fluid brand_logo"
                  alt="Light logo"
                />
              </Link>
              <button
                onClick={() => setMenuOpen(false)}
                className="text-white underline"
              >
                Close
              </button>
              <Link
                to="/"
                className="primary_btn_outline primary_btn_outline_white hidden md:block"
              >
                Request a Consultation
              </Link>
            </div>

            {/* SPLIT LAYOUT */}
            <div className="grid grid-cols-1 h-full relative">
              {/* LEFT - MENU */}
              <motion.div
                variants={containerVariants}
                className="flex flex-col lg:flex-row justify-start lg:justify-center items-center lg:items-start gap-6 md:gap-8 lg:gap-10 xl:gap-20 z-20 mt-10 lg:mt-16"
              >
                {menuItems.map((item, i) => (
                  <motion.div
                    key={i}
                    variants={itemVariants}
                    className="relative cursor-pointer group flex flex-col items-center lg:items-start overflow-visible"
                    onMouseEnter={() => setHoveredMenuItem(i)}
                    onMouseLeave={() => setHoveredMenuItem(null)}
                  >
                    <Link
                      to={item.path}
                      onClick={(e) => {
                        e.preventDefault();
                        setMenuOpen(false);
                        // Scroll to top if Home
                        if (item.path === "/") {
                          navigate("/");
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }
                        // Scroll to element if it's an anchor link
                        else if (item.path.startsWith("#")) {
                          // If not on home page, navigate to home first
                          if (location.pathname !== "/") {
                            navigate("/");
                            setTimeout(() => {
                              const element = document.querySelector(item.path);
                              if (element) {
                                element.scrollIntoView({ behavior: "smooth" });
                              }
                            }, 500);
                          } else {
                            // Already on home page, just scroll
                            const element = document.querySelector(item.path);
                            if (element) {
                              element.scrollIntoView({ behavior: "smooth" });
                            }
                          }
                        }
                      }}
                      className="no-underline flex flex-col items-center lg:items-start w-full"
                    >
                      {/* Menu Text Container - Animated */}
                      <div className="relative h-12 md:h-14 lg:h-16 overflow-hidden flex items-center justify-center lg:justify-start">
                        {/* Original Forum Font */}
                        <motion.div
                          animate={
                            hoveredMenuItem === i
                              ? { y: -100, opacity: 0 }
                              : { y: 0, opacity: 1 }
                          }
                          transition={{ duration: 0.4, ease: "easeInOut" }}
                          className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-[4xl] font-normal font-['Forum'] text-[#acc6b7]"
                        >
                          {item.name}
                        </motion.div>

                        {/* Roobert Font - Coming from bottom */}
                        <motion.div
                          animate={
                            hoveredMenuItem === i
                              ? { y: 0, opacity: 1 }
                              : { y: 100, opacity: 0 }
                          }
                          transition={{ duration: 0.4, ease: "easeInOut" }}
                          className="absolute text-1.5xl sm:text-2xl md:text-2xl lg:text-2xl xl:text-[3xl] font-normal font-['Roobert'] text-white"
                        >
                          {item.name}
                        </motion.div>
                      </div>

                      {/* Underline */}
                      <span className="absolute left-1/2 lg:left-0 -translate-x-1/2 lg:translate-x-0 -bottom-2 w-0 h-[2px] bg-white transition-all duration-500 group-hover:w-full"></span>
                    </Link>
                  </motion.div>
                ))}
              </motion.div>
              {/* RIGHT - IMAGE (BOTTOM) */}
              <div className="absolute bottom-[80px] sm:bottom-[90px] right-0 left-0">
                <motion.img
                  src={require("../assets/images/home/menu_bg.png")}
                  alt=""
                  variants={imageVariants}
                  className="mix-blend-screen opacity-40 lg:opacity-100 m-auto"
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
